<template>
  <section class="cta section center-content" :class="[hasBgColor && 'has-bg-color', invertColor && 'invert-color']">
    <div class="container">
      <div class="cta-inner section-inner" :class="[topDivider && 'has-top-divider', bottomDivider && 'has-bottom-divider', split && 'cta-split']">
        <div class="container-xs">
          <div class="cta-slogan reveal-from-top">
            <h2 class="mt-0 mb-16">
              Ready to get started?
            </h2>
            <p class="m-0">Join the {{ servers }} servers and {{ users }} total users already using SRVControl.</p>
          </div>
          <div class="cta-action reveal-scale-up" data-reveal-delay="200">
            <c-button tag="a" color="primary" wide-mobile href="/docs">
              Get Started
            </c-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionProps } from '@/utils/SectionProps.js';
import CButton from '@/components/elements/Button.vue';

export default {
  name: 'CCta',
  components: {
    CButton
  },
  mixins: [SectionProps],
  props: {
    split: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      servers: 0,
      users: 0
    };
  },
  async beforeCreate() {
    await this.$http.get('https://api.srvcontrol.net').then(({ data }) => {
      this.servers = this.formattedNum(data.guilds);
      this.users = this.formattedNum(data.users);
    });
  },
  methods: {
    formattedNum: function(x) {
      return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
    }
  }
};
</script>
